export const GOT_QUOTES = 'got-quotes';

const gotQuotes = ({
  locations,
  curatedLocations,
  selectedLocation,
  selectedQuote,
  currentSearch,
}) => ({
  type: GOT_QUOTES,
  payload: {
    locations,
    curatedLocations,
    selectedLocation,
    selectedQuote,
    currentSearch,
  },
});

export default gotQuotes;
